import { render, staticRenderFns } from "./BookmarkDelete.vue?vue&type=template&id=a56b995c&"
import script from "./BookmarkDelete.vue?vue&type=script&lang=js&"
export * from "./BookmarkDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports